import { render, staticRenderFns } from "./formLaporan.vue?vue&type=template&id=1f1be216"
import script from "./formLaporan.vue?vue&type=script&lang=js"
export * from "./formLaporan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports